import { Pipe, PipeTransform } from '@angular/core';
import { prettyPrintSeconds } from '../utilities/prettyPrintMinutes';

@Pipe({
  name: 'prettyPrintSeconds',
})
export class PrettyPrintSecondsPipe implements PipeTransform {
  public transform(seconds: number): string {
    return prettyPrintSeconds(seconds);
  }
}
